import { client } from '@/lib/httpClient';
import {
  Section,
  SectionEntry,
  SectionEntryResponse,
  SectionCategory,
  SectionCategoryEntry,
  SectionCategoryEntryResponse,
} from '@/types/section.types';
import { ActionStatus } from '@/types/api.types';
import { sectionEntrySchema, sectionCategoryEntrySchema } from '@/schemas/section.schemas';

// Section CRUD operations
export const getSections = async (): Promise<Section[]> => {
  const { data } = await client.get<Section[]>('/api/v1/sections/');
  return data;
};

export const getSectionById = async (sectionId: string): Promise<Section> => {
  const { data } = await client.get<Section>(`/api/v1/sections/${sectionId}`);
  return data;
};

export const addSection = async (section: SectionEntry): Promise<SectionEntryResponse> => {
  const validatedData = sectionEntrySchema.parse(section);
  const { data } = await client.post<SectionEntryResponse>('/api/v1/sections/', validatedData);
  return data;
};

export const updateSection = async (sectionId: string, section: SectionEntry): Promise<ActionStatus> => {
  const validatedData = sectionEntrySchema.parse(section);
  const { data } = await client.put<ActionStatus>(`/api/v1/sections/${sectionId}`, validatedData);
  return data;
};

export const deleteSection = async (sectionId: string): Promise<ActionStatus> => {
  const { data } = await client.delete<ActionStatus>(`/api/v1/sections/${sectionId}`);
  return data;
};

// Section Categories operations
export const getSectionCategories = async (sectionId: string): Promise<SectionCategory[]> => {
  const { data } = await client.get<SectionCategory[]>(`/api/v1/sections/${sectionId}/categories`);
  return data;
};

export const addSectionCategory = async (
  sectionId: string,
  category: SectionCategoryEntry
): Promise<SectionCategoryEntryResponse> => {
  const validatedData = sectionCategoryEntrySchema.parse(category);
  const { data } = await client.post<SectionCategoryEntryResponse>(
    `/api/v1/sections/${sectionId}/categories`,
    validatedData
  );
  return data;
};

export const deleteSectionCategory = async (
  sectionId: string,
  sectionCategoryId: string
): Promise<ActionStatus> => {
  const { data } = await client.delete<ActionStatus>(
    `/api/v1/sections/${sectionId}/categories/${sectionCategoryId}`
  );
  return data;
};
